<template>
<div>
  <div class="flex justify-around items-center m-2 w-full">
  <div class="video-options">
        <select ref="cameraOptions" name="" id="" class="custom-select">
          <option value="">Select camera</option>
        </select>
  </div>
  <div ref="controls" id="control-video" class="controls">
      <button ref="play" class="d-flex bg-red-600 items-center btn btn-danger play" title="Play">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="trash w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" />
        </svg>

      </button>
      <!-- <button ref="pause" class="d-none d-flex items-center btn btn-info pause" title="Pause">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 5.25v13.5m-7.5-13.5v13.5" />
        </svg>
      </button> -->
      <button
        ref="screenshot"
        class="d-none d-flex items-center btn btn-outline-success screenshot"
        title="ScreenShot"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z" />
        </svg>

      </button>
    </div>
  </div>
  <div class="display-cover w-full md:w-4/5 flex-col-reverse">
    <video ref="video" autoplay></video>
    <canvas ref="canvas" class="d-none"></canvas>
  </div>
  <div class="flex flex-col md:flex-row  justify-center items-center ">
      <div class="screenshot-image w-4/5 md:w-1/3 m-3" v-for="image in listImages"  :key="image">
        <div class="opacity-hover d-flex items-center justify-center">
          <button class="absolute" @click="deleteImage(image.document_type)" title="Play">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="trash w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </button>
        </div>
        
        <img :src="image.file_base64"/>
        <p class="text-xs md:text-sm m-0 m-1">
          {{image.document_type}}
        </p>
       
      </div>
    </div>
  <div class="mt-4 w-full md:w-1/2 mx-auto md:px-5 sm:text-center">
    <button class="px-5 py-2 text-white w-full bg-orange-500  text-white text-center"
      @click="uploadDocuments">
        Siguiente
      </button>
  </div>
  </div>
</template>
<script>
import { ref, onMounted,onBeforeUnmount } from "vue";
import axios from "axios";
import Swal from "sweetalert2";
import { useRouter } from 'vue-router';

export default {
  name: "OpenCameraMobile",
  setup() {
    const ccapi = process.env.VUE_APP_CCAPI + 'cabsaaye/documents/upload';
    const camera = ref(null);
    const controls = ref(null);
    const cameraOptions = ref(null);
    const video = ref(null);
    const canvas = ref(null);
    const buttons = ref(null);
    //const pause = ref(null);
    const play = ref(null);
    const screenshot = ref(null);
    const listImages = ref([]);
    const router = useRouter();
    let streamStarted = false;

    const rfcDocument = ref("");
        

    onMounted(() => {
        getCameraSelection();
        startRecording();
        getRFCStorage();
    });
    onBeforeUnmount(() => {
      camera.value?.stop()
    })
    
    const getRFCStorage = () => {
      const rfc_applicant = localStorage.getItem("rfc_applicant");
      const rfc_client = localStorage.getItem("rfc_client");
      if(rfc_client !== null){
        rfcDocument.value = rfc_client;
      }
      else{
        rfcDocument.value = rfc_applicant
      }
    }
    function isMobile(){
      if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
        return true
      }
      return false;
    }
    function startRecording() {

    const constraints = {
      video: {
        width: {
          min: 1280,
          ideal: 1920,
          max: 2560,
        },
        height: {
          min: 720,
          ideal: 1080,
          max: 1440,
        },
        facingMode: isMobile() ? {exact: "environment"} : "environment"
      },
    };
    console.log(constraints)

    cameraOptions.value.onchange = () => {
      const updatedConstraints = {
        ...constraints,
        deviceId: {
          exact: cameraOptions.value,
        },
      };

      startStream(updatedConstraints);
    };

    play.value.onclick = () => {
      if (streamStarted) {
        video.value.play();
        play.value.classList.add("d-none");
        //pause.value.classList.remove("d-none");
        return;
      }
      if ("mediaDevices" in navigator && navigator.mediaDevices.getUserMedia) {
        const updatedConstraints = {
          ...constraints,
          deviceId: {
            exact: cameraOptions.value,
          },
        };
        startStream(updatedConstraints);
      }
    };

    

    const doScreenshot = async () => {
      canvas.value.width = video.value.videoWidth;
      canvas.value.height = video.value.videoHeight;
      canvas.value.getContext("2d").drawImage(video.value, 0, 0);
      console.log("canvas: ", canvas);
      const imagen = new Image();
      const img = canvas.value.toDataURL("image/jpeg");
      imagen.src = img

      const compressed_image = await compress_Image(img, 70);
      const fileAttributes = get_document_attributes(compressed_image);
      const theMaximunSize = exceedTheMaximunSize(1487653, fileAttributes.size);
      console.log(fileAttributes)
      console.log(theMaximunSize)
       /*console.log(imagen);
      console.log(img); */

      
      
      const imageStructure = {
        document_type: 'INE FRONTAL' ,
        name: "INE",
        extension: fileAttributes.extension,
        file_base64: img
      }
      console.log(imageStructure);

      listImages.value.map((image) => {
        if(image.document_type == "INE FRONTAL"){
          imageStructure.document_type = "INE POSTERIOR";
        }
      })
      if(listImages.value.length < 2){
        listImages.value.push(imageStructure);
      }
      
    };
 
    

    const compress_Image = (imagenComoArchivo, porcentajeCalidad) => {
      return new Promise((resolve, reject) => {
        const $canvas = document.createElement("canvas");

        const imagen = new Image();
        imagen.onload = () => {
          $canvas.width = imagen.width;
          $canvas.height = imagen.height;
          $canvas.getContext("2d")?.drawImage(imagen, 0, 0);
          $canvas.toBlob(
            (blob) => {
              if (blob === null) {
                return reject(blob);
              } else {
                resolve(blob);
              }
            },
            "image/jpeg",
            porcentajeCalidad / 100
          );
        };
        imagen.src = imagenComoArchivo
      });
    };

    function get_document_attributes(document) {
      const attributes = {};
      //attributes.name = document.name;
      attributes.extension = document.type.split("/")[1];
      attributes.completeExtension = `.${document.type.split("/")[1]}`;
      attributes.size = parseInt(document.size);

      return attributes;
    }
    
    function exceedTheMaximunSize(maxSize, size) {
      return size > maxSize;
    }

   

    

    /* pause.value.onclick = pauseStream; */
    screenshot.value.onclick = doScreenshot;

    const startStream = async (constraints) => {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      camera.value = stream.getTracks()[0];
      handleStream(stream);
    };

    const handleStream = (stream) => {
      video.value.srcObject = stream;
      play.value.classList.add("d-none");
      //pause.value.classList.remove("d-none");
      screenshot.value.classList.remove("d-none");
    };
    }

    async function uploadDocuments(){
      console.log(listImages);
      if(listImages.value.length === 1 || listImages.value.length === 2){
        var cleanBase64Docs = JSON.parse( JSON.stringify( listImages.value ) );

        const documents = cleanBase64Docs.map(doc => {
          doc.file_base64 = doc.file_base64.split("data:image/jpeg;base64,")[1];
          return doc
        });
        
        const data = {
          token_auth: "eyJhbGciOiJIUzI1NiJ9.eyJhcGlrZXkiOiIwdTNoSlNabEJ4Y0RaUDlUOUo0aHJ3IiwidmVyc2lvbiI6InYxIiwiZXhwIjoxNjcxMDU3MzEzfQ.PNgFE5rwaVcCXAyMGiBzbAfu8piNGlNF-WYYr9dgHFw",
          rfc: rfcDocument.value,
          folio: "1000112",
          documents,
        };
        const response = await axios.post(`${ccapi}`,data);
        console.log("response: ", response)
        if(response.status === 200) {
          const document_response = response.data.response.result;
          const documents_identify = []; 
          document_response.map((data) => {
            const side = data.document_name.split('_')[2];
            if(side === "FRONTAL"){
                const cloud_key = data.url.split("/")[6];
                documents_identify[0] = {
                  cloud_url: data.url,
                  document_name: data.document_name,
                  document_type: "INE FRONTAL",
                  cloud_key,
                }
              }
              if(side === "POSTERIOR"){
                const cloud_key = data.url.split("/")[6];
                documents_identify[1] = {
                  cloud_url: data.url,
                  document_name: data.document_name,
                  document_type: "INE POSTERIOR",
                  cloud_key,
                }
              }
            
          })
          let policy =  JSON.parse(localStorage.getItem("policy"));
            policy.document_list = documents_identify;
            localStorage.setItem("policy", JSON.stringify(policy));
            router.push({name: 'resume'})
        }
      } else {
        Swal.fire({
          title: "Aviso",
          html: `Por lo menos debe capturar una imagen de INE/IFE`,
          icon: "error",
        });
      }
    }
    const getCameraSelection = async () => {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(
        (device) => device.kind === "videoinput"
      );
      const options = videoDevices.map((videoDevice) => {
        return `<option value="${videoDevice.deviceId}">${videoDevice.label}</option>`;
      });
      cameraOptions.value.innerHTML = options.join("");
    };

    function deleteImage(name){
      const index = listImages.value.findIndex(img => {
        return img.name === name;
      });
      listImages.value.splice(index, 1);
    }

    

    
    return {
      buttons,
      controls,
      cameraOptions,
      play,
      //pause,
      screenshot,
      video,
      canvas,
      listImages,
      deleteImage,
      uploadDocuments,
    };
  },
};
</script>
<style>
.screenshot-image:hover > .opacity-hover{
  position: absolute;
  width: 100%;
  height: 100%;
  background: #0000005c;
}
.trash{
  color: #fff; 
}
.opacity-hover > button {
  display: none;
}
.screenshot-image:hover > .opacity-hover > button {
  position: absolute;
  display: flex;
  color: #fff;
}


.screenshot-image:hover > button > svg {
  color: #fff;
  font-size: 23px;
}
.download{
    position: absolute;
}
.screenshot-image {
  border-radius: 4px;
  border: 2px solid whitesmoke;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background: white;
  position: relative;
}
.delete-image{
  position: absolute;
  top: 0;
  right: 0;
}

.display-cover {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  position: relative;
}

video {
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
}

.controls > button {
  width: 45px;
  height: 45px;
  text-align: center;
  border-radius: 100%;
  margin: 0 6px;
  background: transparent;

  &:hover {
    svg {
      color: white !important;
    }
  }
}

@media (min-width: 300px) and (max-width: 400px) {
  .controls {
  }
  button {
      margin: 5px 0 !important;
  }
}

.controls > button > svg {
  height: 20px;
  width: 18px;
  text-align: center;
  margin: 0 auto;
  padding: 0;
}

.controls button:nth-child(1) {
  border: 2px solid #d2002e;

  svg {
    color: #d2002e;
  }
}

.controls button:nth-child(2) {
  border: 2px solid #008496;

  svg {
    color: #008496;
  }
}

.controls button:nth-child(3) {
  border: 2px solid #00b541;

  svg {
    color: #00b541;
  }
}

.controls > button {
  width: 45px;
  height: 45px;
  text-align: center;
  border-radius: 100%;
  margin: 0 6px;
  background: transparent;

  &:hover {
    svg {
      color: white;
    }
  }
}
</style>
